import { useMemo } from 'react';
import { useWorkingHours } from './useWorkingHours';
import { restDaysFromWorkingHours } from '@utils/workCalendar';

/**
 * Rest-day weekday set (0=Sun … 6=Sat) for a site.
 * Primary source: the schedule's own `weeklyDaysOff` (Genba 週休日). When that is
 * non-empty we use it and DO NOT fetch working-hours at all. The Trusstor
 * working-hours endpoint is a fallback, fetched ONLY when weeklyDaysOff is known
 * to be empty (schedule loaded, blank 週休日). `weeklyDaysOff === undefined` means
 * the schedule hasn't loaded yet → don't fetch the fallback prematurely.
 */
export function useSiteRestDays(siteId: string | undefined, weeklyDaysOff: number[] | undefined): Set<number> {
  const phase = weeklyDaysOff === undefined ? 'loading' : weeklyDaysOff.length > 0 ? 'genba' : 'fallback';
  // Only fetch when genba gave nothing.
  const wh = useWorkingHours(siteId, phase === 'fallback');
  return useMemo(() => {
    if (phase === 'genba') return new Set(weeklyDaysOff);
    if (phase === 'fallback' && wh.data) return restDaysFromWorkingHours(wh.data);
    return new Set<number>();
  }, [phase, weeklyDaysOff, wh.data]);
}
